import { render } from "./JourneyJoinLandingPage.vue?vue&type=template&id=30ae4d3e&scoped=true"
import script from "./JourneyJoinLandingPage.vue?vue&type=script&lang=js"
export * from "./JourneyJoinLandingPage.vue?vue&type=script&lang=js"

import "./JourneyJoinLandingPage.vue?vue&type=style&index=0&id=30ae4d3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ae4d3e"]])

export default __exports__